/**
 * Where every way INTO a demo session navigates (#15599): the root, so the
 * demo org lands wherever its saved `landingPath` says — the same front door
 * a real sign-in uses — with the root redirect's gate and Today fallback
 * (`ROOT_LANDING_PARAM` in `@/lib/org-nav/vocabulary`). Never `/today`: an
 * explicit `/today` ignores the saved landing page.
 *
 * Its own module so client components can import it without pulling in the
 * nav vocabulary's icon set.
 */
export const DEMO_ENTRY_PATH = '/'
